import React from 'react';

const AppFooter = (props: any) => {
    return (
        <div className="layout-footer">
            {/* <div>
                <span>Designed &amp; Developed By&nbsp;</span>
                <a
                    href="https://helicoreinfo.com"
                    style={{ textDecoration: "none" }}
                    rel="noreferrer"
                    target="_blank"
                >
                    <img className='footer-logo'
                        src="https://gujaratpharmacycouncil.co.in/front/favicon-helicore.png"
                        width="32"
                        height="32"
                        alt="footer-logo"
                    />
                    <span className="black-txt">&nbsp;Helicore Info Pvt. Ltd.</span>
                </a>
            </div> */}
        </div>
    );
};

export default AppFooter;
